import React, { useEffect, useRef } from 'react';
import { useLocation, useParams } from 'react-router';

import { ErrorBoundary } from 'components/ErrorBoundary.js';
import Filters from './Filters.js';
import ScreenHeaderLoader from './ScreenHeaderLoader.js';
import ScreenHeaderTabs from './ScreenHeaderTabs.js';
import { action } from '../lib/actionHelpers.js';
import { darkModeRouteParams } from 'lib/utilities';
import selectors from '../selectors/selectors.js';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import setQuery from 'lib/setQuery.js';
import { useRouteMatch } from 'react-router';

const ScreenHeader = ({ tabs = [], filters = [], onTabClick, loading, param }) => {
  const isMobile = useSelector(selectors.mobile);
  const { reportType, serviceProviderId} = useParams();
  const { replace } = useHistory();
  const { pathname } = useLocation();
  const tabsRef = useRef(tabs);
  const serviceProviderIdRef = useRef(serviceProviderId)
  const search = useSelector((state) => state.ui.filters.search);
  const tabsDep = JSON.stringify(tabs.map((n) => n.id))

  useEffect(() => {
    tabsRef.current = tabs;
    serviceProviderIdRef.current = serviceProviderId;
  }, [tabsDep,serviceProviderId]);

  const handleTabClick = (e, tab, opts = {}) => {
    if ((tab || {}).onClick) {
      (tab || {}).onClick();
    }
    if (param) {
      setQuery({ [param]: tab.id, eid: null, lead: null, modal: null, tab: null, etype: null, filter: null });
      if (typeof onTabClick === 'function' && !opts.silent) {
        onTabClick(e, tab.id);
      }
      return;
    }
    if (pathname !== tab.slug) {
      const tabSlugServiceProviderId = (tab.slug || "").split('/')
      if(tabSlugServiceProviderId[1] && tabSlugServiceProviderId[1] === serviceProviderIdRef.current)
      replace({ pathname: tab.slug });
      if (search) {
        action('uiPatchFilters', { search: '' });
      }
    }
    if (typeof onTabClick === 'function' && !opts.silent) {
      onTabClick(e, tab, { routeChanged: pathname !== tab.slug });
    }
  };

  useEffect(() => {
    const activeTab = (tabsRef.current || []).find((n) => n.slug === pathname);
    const defaultTab = (tabsRef.current || []).find((n) => n.default && n.slug);
    if (!activeTab && defaultTab) {
      handleTabClick(undefined, defaultTab, { silent: true });
    }
  }, []);

  if (loading && !isMobile) {
    return <ScreenHeaderLoader />;
  }

  return (
    <div className={`screen-header ${darkModeRouteParams.includes(reportType) ? 'dark-mode' : ''}`}>
      <ErrorBoundary>
        <div className="screen-tabs-row">
          <ScreenHeaderTabs tabs={tabs.filter((n) => n.hidden !== true)} onTabClick={handleTabClick} param={param} />
          <div className="screen-filters">{!!filters.length && <Filters filters={filters} />}</div>
        </div>
      </ErrorBoundary>
    </div>
  );
};

export default ScreenHeader;
